import { PortalError } from './PortalError';

export class UnknownClassificationError extends PortalError {
  constructor() {
    super('UnknownClassificationError', `Unknown bloodpressure classification`);
  }
}
